export const SET_USER_ID = 'SET_USER_ID';
export const SET_FINGERPRINT_ID = 'SET_FINGERPRINT_ID';